import React from 'react';
import { Card } from '../ui/Card';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
const destinations = [{
  country: 'United Kingdom',
  flag: '🇬🇧',
  count: '150+ Programs',
  tagline: 'Home of prestigious universities',
  image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
}, {
  country: 'USA',
  flag: '🇺🇸',
  count: '200+ Programs',
  tagline: 'Land of opportunity & innovation',
  image: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
}, {
  country: 'Canada',
  flag: '🇨🇦',
  count: '120+ Programs',
  tagline: 'Quality education & post-study work',
  image: 'https://images.unsplash.com/photo-1517935706615-2717063c2225?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
}, {
  country: 'Australia',
  flag: '🇦🇺',
  count: '100+ Programs',
  tagline: 'World-class research & lifestyle',
  image: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
}, {
  country: 'Germany',
  flag: '🇩🇪',
  count: '80+ Programs',
  tagline: 'Excellence in engineering & tech',
  image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
}, {
  country: 'Malaysia',
  flag: '🇲🇾',
  count: '50+ Programs',
  tagline: 'Affordable quality education',
  image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
}];
export function DestinationsSection() {
  return <section className="py-20 bg-[#faf8f5]" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="text-center mb-16" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-40">
            Top Study Destinations
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-41">
            Explore educational opportunities in the world's most sought-after
            countries.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-42">
          {destinations.map((dest, index) => <Card key={dest.country} noPadding hoverEffect initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="group cursor-pointer h-full flex flex-col" data-id="element-43">
              <div className="relative h-48 overflow-hidden" data-id="element-44">
                <img src={dest.image} alt={dest.country} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-45" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-46"></div>
                <div className="absolute bottom-4 left-4 text-white" data-id="element-47">
                  <span className="text-4xl mb-2 block" data-id="element-48">{dest.flag}</span>
                  <h3 className="text-xl font-bold" data-id="element-49">{dest.country}</h3>
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-50">
                <p className="text-gray-600 mb-4 flex-1" data-id="element-51">{dest.tagline}</p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100" data-id="element-52">
                  <span className="text-sm font-medium text-[#1e3a5f] bg-blue-50 px-3 py-1 rounded-full" data-id="element-53">
                    {dest.count}
                  </span>
                  <div className="flex items-center text-[#f59e0b] text-sm font-medium group-hover:translate-x-1 transition-transform" data-id="element-54">
                    Explore <MapPin className="h-4 w-4 ml-1" data-id="element-55" />
                  </div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}